import React from "react";
import { Popover, Tag } from "antd";
import { getSymbolById } from "../../FloorPlanModal/utils/symbolTypes";

// Mirrors FloorPlanModal/components/StationPopover.jsx's visual shape (a
// coloured Tag + name, then muted detail lines) so 機具/基站 popovers read
// as one family, not two ad-hoc designs.
const DETAIL_LINE_STYLE = {
  marginTop: 8,
  fontSize: 12,
  color: "#8c8c8c",
};

// This is the ONLY place `（警報關閉）` still appears now that the floating
// name label is gone (see ADDENDUM F1b) -- dropping it here would silently
// hide a machine that looks normal on the canvas but will never alarm.
const AlertLine = ({ alertEnabled, alertRadiusMeters }) => (
  <div style={DETAIL_LINE_STYLE}>
    警報:{" "}
    <span
      style={{
        color: alertEnabled ? "#8c8c8c" : "#ff4d4f",
        fontWeight: alertEnabled ? "normal" : "bold",
      }}
    >
      {alertEnabled ? "開" : "關"}
    </span>
    {alertRadiusMeters != null && `，警戒半徑 ${alertRadiusMeters}m`}
  </div>
);

const ROLE_LABEL = { head: "頭", tail: "尾" };

const TagList = ({ tags }) => {
  if (!tags?.length) return null;
  return (
    <div style={DETAIL_LINE_STYLE}>
      定位器:
      {tags.map((tag) => (
        <div key={tag.id} style={{ marginTop: 2 }}>
          {tag.name}
          {ROLE_LABEL[tag.role] && `（${ROLE_LABEL[tag.role]}）`} -{" "}
          {tag.fresh ? "回報中" : "未回報"}
        </div>
      ))}
    </div>
  );
};

// `isFaulty` comes from the caller's getEquipmentFaultState, NOT item.status
// -- status reports a healthy single-tag machine as "stale", which would
// make this line contradict what's painted on the canvas (see F1b).
// Unlike StationPopover, this is only ever mounted for plane-layout markers
// (EquipmentLayer renders EquipmentLaneMarkers, not this component, for
// line/tunnel), so there is no cross-layout "wrong tab is open" case to
// guard against with a layoutType comparison.
const EquipmentPopover = ({
  item,
  isFaulty,
  isOpen,
  children,
  onOpenChange,
  trigger = "click",
}) => {
  const symbol = getSymbolById(item.symbolType);
  const color = symbol?.color || "#722ed1";

  return (
    <Popover
      content={
        <div>
          <div
            style={{
              fontWeight: "bold",
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <Tag color={color} style={{ margin: 0, fontSize: "11px" }}>
              {symbol?.name || "未分類"}
            </Tag>
            {item.name || "未命名機具"}
          </div>
          <AlertLine
            alertEnabled={item.alertEnabled}
            alertRadiusMeters={item.alertRadiusMeters}
          />
          {item.spanMeters != null && (
            <div style={DETAIL_LINE_STYLE}>機具長度: {item.spanMeters}m</div>
          )}
          <div style={DETAIL_LINE_STYLE}>
            狀態: {isFaulty ? "定位異常" : "定位正常"}
          </div>
          <TagList tags={item.tags} />
        </div>
      }
      trigger={trigger}
      open={isOpen}
      onOpenChange={onOpenChange}
    >
      {children}
    </Popover>
  );
};

export default EquipmentPopover;
